import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { RequestService } from '../../../services/Request/RequestService'

export interface IRequestDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  request: any
  onDelete: () => void
  leastDestructiveRef: any
}

export function RequestDeleteDialog({
  isOpen,
  onClose,
  request,
  onDelete,
  leastDestructiveRef
}: IRequestDeleteDialogProps) {
  const requestService = new RequestService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await requestService.delete(request.id)

      toast({
        title: 'Solicitação deletada',
        description: 'Solicitação deletada com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onDelete()
      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao deletar solicitação',
        description: 'Erro ao deletar solicitação, tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Deletar solicitação
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja deletar a solicitação?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Deletar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
